import './ReviewStar.scss';

import React from 'react';
import StarIcon from "../../../icons/StarIcon";
import {IconSize} from "../../../services/IconConstants";

interface Props {
    active: boolean,
    onPress: () => void,
}

const ReviewStar = ({active, onPress}: Props) => {

    return (
        <div style={{ borderColor: active ? 'var(--selectableContentBorder)' : 'var(--unselectableContentBorder)'}}
             className={"reviewStar_container"}
             onClick={onPress}>
            <StarIcon size={IconSize.md} active={active} />
        </div>
    )
}

export default ReviewStar;
